import styled  from 'styled-components';
import { Modal } from 'react-bootstrap';

const Layout = styled.div`
  width: 100%;
  padding: 25px;
  .main{
    width: 100%;
    max-width: 1246px;
    margin: auto;
  }
`;

const BuddyTab = styled.div`
display: flex;
min-width: ${({width}) => width ? "auto" : '114px'};
height: 40px;
padding: ${({padding}) => padding ? "10px 16px" : ''};
background: ${({active}) => active ? '#F37A65' : '#FEFEFE'};
border-radius: 6px;
font-family: ${({active}) => active ? 'Lato' : 'Lato'};
font-size: 18px;
font-weight: 400;
line-height: 20px;
color: ${({active}) => active ? '#FEFEFE' : '#FEFEFE'};
margin: ${({margin}) => margin ? margin : 'auto auto auto 12px'};
white-space: nowrap;
overflow: hidden;
text-overflow: ellipsis;
justify-content: center;
align-items: center;
cursor: pointer;
:hover{
  background:#F37A65;
  color:#FEFEFE;
}
`;

const Header = styled.div`
display:flex;
width:100%;
padding: 8px;
background:white;
border-radius:4px;
.create-consumer{
  // width:190px;
  height:40px;
  display:flex;
  margin: auto 6px auto auto;
}
.add{
  .dropdown-menu{
    min-width:100px;
  }
  div{
    .dropdown{
      .sub-menu-wrapper{
        width: 250px;
        background: white;
        z-index:99999;
        left: 40px;
        border: 1px solid rgba(0,92,135,0.30);
        border-radius: 6px;
        padding: 12px 0px;
        box-shadow: inset 0 3px 5px rgba(0,0,0,.125);
        .sub-menu{
          color: #007AB1;
          font-family: Rubik-medium;
          font-size: 16px;
          font-style: normal;
          font-weight: 500;
          line-height: 20px;
          padding: 4px 0px 4px 12px;
          cursor:pointer;
        }
      }
      button{
        background: none;
        border: none;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 5px;
        margin-top: ${(isEvent)=> isEvent && '3px'};
        ${'' /* padding-left: ${(isEvent)=> isEvent && '0px'}; */}
        padding-left: 0px;
        padding-right: 0px;
        margin-right: 0px;
        margin-left: 0px;
        &:active{
          background: none;
          border: none;
        }
      }
      .dropdown-menu.show{
        display: inline-flex;
        padding: 12px;
        justify-content: center;
        align-items: center;
        transform: translate3d(-13px, 50px, 0px);
        border-radius: 4px;
        border: 1px solid rgba(0, 92, 135, 0.30);
        background: #FFF;
        display: flex;
        flex-direction: column;
        margin-left: -45px;
        a{
          color: #007AB1;
          font-family: Rubik-medium;
          font-size: 16px;
          font-style: normal;
          font-weight: 500;
          line-height: 20px;
          display:flex;
          >svg{
            display:flex;
            margin:auto 0 auto auto;
            transform:rotate(0deg);
          }
          &:active{
            background: none;
          }
        }
        hr{
          width: 90%;
          color: rgba(0, 92, 135, 0.50);
        }
      }
    }
  }
}
`;

const NoData = styled.div`
display:flex;
width:100%;
flex-wrap:wrap;
margin-top: ${({margin}) => margin ? margin : '0'};
.image{
    width: 388px;
    height: 250px;
    display:flex;
    margin:auto;
    >img{
        width:100%;
        height:100%;
    }
}
.text{
    width:100%;
    display:flex;
    font-family: Rubik;
    font-size: 16px;
    font-weight: 400;
    line-height: 20px;
    text-align: center;
    color:#005c87;
    text-align:center;
    justify-content:center;
    margin-top:40px;
}
`;

const AddUserCard = styled.div`
position:relative;
width: 300px;
display:flex;
margin: auto 0px auto auto;
flex-wrap: wrap;
left: 7px;
bottom: 5px;
.hand{
    width: 100%;
    display:flex;
    .image{
        height: 48px;
        width: auto;
        display:flex;
        margin: auto 8px auto auto;
        >img{
            width:100%;
            height:100%;
        }        
    }
}
.adduser{
width: 300px;
border-radius: 6px;
border: 1px solid #005C87;
box-shadow: 0px 13px 28px 0px #0000004D;
background:white;
padding:12px;
.heading{
    font-family: Rubik-Medium;
    font-size: 16px;
    font-weight: 500;
    line-height: 18.96px;
    text-align: left;
    color: #005c87;
    padding-bottom: 12px;
  }
.subtext{
    font-family: Rubik;
    font-size: 16px;
    font-weight: 400;
    line-height: 20px;
    text-align: left;
    color: #005c87;
    border-bottom:1px solid #005C874D;
    padding-bottom: 12px;
  }
.skip{
    width:100%;
    display:flex;
    justify-content:flex-end;
    font-family: Rubik;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    text-align: center;
    color: #007AB1;
    padding-top:12px;
    cursor:pointer;
  }
}
`;

const HeaderTitle = styled.div`
width:100%;
display:flex;
margin: 32px 0;
flex-wrap: nowrap;
align-item:center;
.text{
    font-family: Rubik-Medium;
    font-size: 18px;
    font-weight: 500;
    line-height: 24px;
    text-align: left;
    color: #005c87;
    display:flex;
    align-item:center;
}
.line{
    background: #005C874D;
    display:flex;
    width:auto;
    align-items:center;
    height:1px;
    width: calc(100% - 105px);
    display:flex;
    align-items:center;
    margin:auto 0px auto 12px;
}
`;

const ButtonHris = styled.div`
    width: ${({width}) => width ? width : '100%'};
    height: 40px;
    display:flex;
    background: ${({disable}) => disable ? "#EFEFEF" : '#F37A65'};
    cursor: ${({disable}) => disable ? "not-allowed" : 'pointer'};
    border-radius:6px;
    font-family: Lato;
    font-size: 16px;
    line-height: 20px;
    text-align: center;
    color: ${({disable}) => disable ? "#989898" : '#FEFEFE'};
    justify-content: center;
    align-items: center;
    margin-top: ${({ margin }) => margin ? margin : ''};
    .addicon{
      width:25px;
      height:25px;
      margin-right:8px;
    }
`;

const HrisCard = styled.div`
width: 400px;
border-radius: 6px;
background:white;
padding: 12px;
display:flex;
flex-wrap: wrap;
margin-right: 15px;
.wrapper{
    width:100%;
    display:flex;
    margin-bottom: 16px;
    .image{
        width: 140px;
        height:140px;
        border: 1px solid #005C871A;
        border-radius:6px;
        >img{
            width: auto;
            height: 100%;
            max-width: 120px;
        }
    }
    .details{
        padding: 0 16px 0px 20px;
        display:flex;
        flex-wrap:wrap;
        .lastsync{
            font-family: Rubik;
            font-size: 14px;
            font-weight: 400;
            line-height: 20px;
            text-align: left;
            color: #005C87;
            padding-bottom:12px;
            width:100%;
            align-items: center;
            display: flex;
        }
        .nextsync{
            font-family: Rubik;
            font-size: 14px;
            font-weight: 400;
            line-height: 20px;
            text-align: left;
            color: #005C87;
            padding-bottom:8px;
            width:100%;
            align-items: center;
            display: flex;
        }

    }
}
`;

const Time = styled.div`
  width:100%;
  display:flex;
  .timeMain{
   display:block;
  .timeCard{
    width: 43px;
    height: 40px;
    border-radius: 6px;
    display:flex;
    align-items:center;
    justify-content:center;
    font-family: Rubik;
    font-size: 16px;
    font-weight: 400;
    line-height: 20px;
    text-align: center;
    color: #005c87;
    margin-bottom: 5px;
    border: 1px solid var(--navy-30, #005C874D)
  }
  .days{
    font-family: Lato;
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    text-align: center;
    color:#184A61;
    justify-content:center;
  }
}
`;

const TimeIcon = styled.div`
height: 40px;
display:flex;
width: 20px;
align-items:center;
justify-content: center;
`;

const Wrapper = styled.div`
width:100%;
display:flex;
flex-wrap:wrap;
margin-top: ${({margin}) => margin ? margin : '0px'};
.title{
  font-size: 18px;
  line-height: 14px;
  font-family: Lato;
  margin: 0px 0px 20px;
  width: 100%;
  font-weight: 500;
  margin-bottom:20px;
  color:#005c87;
}
.border{
  background:rgba(0, 92, 135, 0.1);
  width:100%;
  height:1px;
  display:flex;
  margin: 10px 0;
}
.sso-card{
 width:400px;
 font-family: Lato;
 font-size: 16px;
 font-weight: 400;
 line-height: 20px;
 text-align: center;
 color: #005c87;
 min-height:60px;
 border-radius:6px;
 background:white; 
 align-items: center;
 padding: 16px;
 display:flex;
 flex-wrap: wrap;
 .content-wrapper{
  display:flex;
  width:100%;
  .image-logo{
    width:120px;
    height:140px;
    border:1px solid #005C871A;
    display: flex;
    >img{
      width:100%;
      display: flex;
      margin:auto;
    }
   }
   .description{
    width:calc(100% - 120px);
    display:flex;
    flex-wrap:wrap;
    padding-left: 20px;
    .sub-text{
      font-family: Lato;
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 20px;
      color: rgb(0, 92, 135);
      width: 100%;
      text-align: left;
      margin: 4px 0;
     }
     .text{
      font-family: Lato;
     font-size: 16px;
     font-weight: 400;
     line-height: 24px;
     text-align: center;
     color: #005c87;
     width:100%;
     text-align: left;
     margin-bottom:4px;
     }
     .menuIcon{
      width: 24px;
      height:24px;
      display:flex;
      margin:auto 0 auto auto;
      >img{
        width:100%;
        height:100%;
      }
     }
   }
 }
 .sub-text{
  font-family: Lato;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  color: rgb(0, 92, 135);
  width: 100%;
  text-align: left;
  margin: 4px 0;
 }
 .text{
  font-family: Lato;
 font-size: 16px;
 font-weight: 400;
 line-height: 24px;
 text-align: center;
 color: #005c87;
 width:100%;
 text-align: left;
 margin-bottom:4px;
 }
 .menuIcon{
  width: 24px;
  height:24px;
  display:flex;
  margin:auto 0 auto auto;
  >img{
    width:100%;
    height:100%;
  }
 }
}
.button-size{
  width:100%;
  display: flex;
  margin: 10px auto 0 auto;
}
`;

const StyledModal = styled(Modal)`
.header{
    width:100%;
    padding: 16px;
    display:flex;
    justify-content:space-between;
    align-items:center;
    border-bottom: 1px solid #005C874D;
    .text{
      font-family: Rubik-Medium;
      font-size: 18px;
      line-height: 24px;
      text-align: left;
      color: #005c87;
      align-items:center;
      display:flex;
    }
    .iconCross{
      width:24px;
      height:24px;
      cursor:pointer;
      >img{
        width:100%;
        height:100%;
      }
    }
}
.body{
  display:flex;
  width:100%;
  padding: ${({paddingV}) => paddingV ? paddingV : '16px'};
  flex-wrap: wrap;
}
.generate-popup{
  height: 200px;
  width:400px;
  display:block;
  .icon{
    width: 100%;
    justify-content: center;
    display: flex;
    margin-top: 70px;
    >img{
      height: 40px;
      width: auto;
    }
  }
  .text{
    justify-content: center;
    display: flex;
    font-family: Lato;
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    letter-spacing: 0%;
    color: #092F41;
    width:100%;
    align-items:center;
    margin-top:16px;
  }
}
.border-line{
  height:1px;
  width:100%;
  background:#EFEFEF;
  margin: ${({margin}) => margin ? margin : '20px 0 20px 0'};
}
.buttonWrapper{
  padding: 8px;
  width:100%;
  display:flex;
}
@media (min-width: 576px){
  .modal-dialog {
    max-width:100% !important;
  }}
  .modal-dialog {
    transform: ${({transform}) => transform ? 'translate(0, 15vh) translate(0, -15%) !important' : 'translate(0, 50vh) translate(0, -50%) !important'};
    margin: ${({change}) => change ? '150px auto' : '0 auto'};
    // box-shadow: 0 5px 15px rgba(0,0,0,.5);
    @media (min-width: 576px){
      .modal-dialog {
        max-width:100% !important;
      }}
    .modal-content{
      border:none;
      box-shadow: 0 5px 15px rgba(0,0,0,.5);
    }
    @media (max-height: 460px) {
      transform: none !important;
      margin: 30px auto;
    }
    width: ${({width}) => width ? width : '490px'};
    height: ${({change, height}) => height? height :change ? '573px' : '473px'};
    @media (max-width: 500px){
      width: 95%;
      height: auto;
    }
  }

  .modal-body{
    padding: ${({padding}) => padding ? padding : '25px 0 25px 0'};
  }
  
  .modal-container {
   width: 100%;
   display: block;
   border: none;
  }
`;

const PopupLine = styled.div`
width:100%;
display:flex;
flex-wrap:wrap;
align-items:center;
margin-bottom:16px;
.checkmark{
  width: 24px;
  height: 24px;
  border-radius:50%;
  display:flex;
  justify-content:center;
  align-items:center;
  border: 1px solid #007AB1;
  cursor:pointer;
  >img{
    width: 16px;
    height:16px;
  }
}
.text{
  font-family: Rubik;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  text-align: left;
  color: #005c87;
  align-items:center;
  display:flex;
  padding-left: 8px;
}
`;

const DownAngle = styled.i`
  float: right;
  font-size: 15px;
  letter-spacing: 0px;
  line-height: 24px;
  cursor: pointer;
  margin-left: 20px;
  .fas {
    margin-right: 4px;
    color: rgb(153,153,153);
  }
  .fa {
    margin-right: 4px;
    color: rgb(153,153,153);
  }  
  @media only screen and (max-width: 767px) {
    position: relative;
    right: 0px;
    margin-left: 38px;
    .btn {
      padding: 0px;
    }
  }
  .dropdown-toggle {
    border: none !important;
    background-color: ${({ background, backgroundColor }) => backgroundColor?"transparent !important": background ? '#F4FAFF !important' : 'transparent !important'};
    box-shadow: none !important;
    padding: 0px;
    .caret {
      display: none;
    }
    > i {
      color: #3A3A3A;
      transform: rotate(90deg);
    }
  }   
  .dropdown-toggle::after{
    border-right:none !important;
    border-left:none !important;
  }
  .dropdown-item{
    color: #007AB1;
    font-family: Rubik-Medium;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    text-align: center;
    padding:0px;
    margin:auto;
    justify-content: center;
    align-items: center;
    display: flex;
    height: 44px;
    &:focus, &:active, &:hover, &:focus-visible {
      color: white;
      background-color: ${({ backgroundV }) => backgroundV?"#F37A65": '#F37A65'};
    }
  }
  .line{
    background:rgba(0,92,135,0.50);
    height:1px;
    width:100%;
  }
  .dropdown-menu {
    margin-left: ${({ width, margin, feed, marginL }) => marginL?marginL: feed?"-95px": margin?"-120px": width ? '-100px' : '-98px'};
    min-width: 120px;
    width: ${({ width, widthV }) => widthV?widthV: width ? 'auto' : '120px !important'};
    border: none;
    margin-top: ${({ margin, feed, marginT }) => marginT?marginT: feed?"-5px": margin ? '0px' : '-10px'};
    border: 1px solid rgba(0, 92, 135, 0.30);
    padding: 0px !important;
    height: ${({ height }) => height ? height : '95px'};
    @media(max-width: 600px) {
      margin-top: -7px;
      margin-left: -86px;
    }
    > li {
      padding:0px;
      border-bottom:1px solid #005C871A;
      :last-child{
        border-bottom:none;
      }
      > a {
        color: #007AB1;
        font-family: Rubik-Medium;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 20px;
        text-align: center;
        padding:0px;
        &:focus, &:active, &:hover, &:focus-visible {
          border: none !important;
          outline: none !important;
        }
      }
    }
  }
`;

const PopupHeading = styled.div`
  display:flex;
  width:100%;
  justify-content:space-between;
  flex-wrap: wrap;
  .title{
    font-family: Lato;
    font-size: 18px;
    font-weight: 700;
    line-height: 24px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: #184A61;
    align-items: center;
    display: flex;
  }
  .close{
    cursor:pointer;
    display: flex;
    align-items: center;
  }
  .subtext{
    font-family: Lato;
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    letter-spacing: 0%;
    color: #BDBDBD;
    width:100%;
    display:flex;
    align-items:center;
    margin-top:4px;

  }
`;

const FormField = styled.div`
width:100%;
display:flex;
justify-content:space-between;
margin-bottom: ${({ margin }) => margin ? margin : '12px'};
.text{
  font-family: Lato;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  display: flex;
  color:#184A61;
  .subtext{
    font-family: Lato;
    font-size: 14px;
    font-weight: 300;
    line-height: 20px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color:#184A613A;
  }
}
.generate{
  width:82px;
  height:32px;
  display:flex;
  justify-content:center;
  align-items:center;
  border:1px solid #F37A65;
  border-radius:4px;
  cursor:pointer;
  font-family: Lato;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  color:#184A61;
}
`;

const ButtonWrapper = styled.div`
width:100%;
display:flex;
justify-content:center;
margin: ${({ margin }) => margin ? margin : '4px 0 0px 0'};
.cancel{
  min-width:80px;
  height:40px;
  display:flex;
  font-family: Lato;
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  color:#184A61;
  justify-content:center;
  align-items:center;
  cursor:pointer;
  border-radius:4px;
  margin-right:16px;
}
.create{
  min-width:156px;
  height:40px;
  background: ${({ disable }) => disable ? '#EFEFEF' : '#DA6C74'};
  padding: 0 16px;
  color: ${({ disable }) => disable ? '#989898' : 'white'};
  justify-content:center;
  align-items:center;
  display:flex;
  font-family: Lato;
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  cursor: ${({ disable }) => disable ? 'not-allowed' : 'pointer'};
  border-radius:4px;
  .icon{
    margin-right:8px;
  }
}
`;

const Heading = styled.div`
width:100%;
display:flex;
font-family: Lato;
font-weight: 700;
font-size: 24px;
line-height: 36px;
color:#184A61;
margin: ${({ margin }) => margin ? margin : '20px 0 20px 0'};
`;

const AddButton = styled.div`
width: ${({ width }) => width ? width : '220px'};
display:flex;
justify-content:center;
cursor:pointer;
border-radius:4px;
padding: 10px 0px;
gap:8px;
border: 1px solid #F37A65;
align-items: center;
margin-top: ${({ margin }) => margin ? margin : ''};
>span{
  font-family: Lato;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: 0%;
  color: #184A61;
}
`;

const BackgroundCard = styled.div`
width: 400px;
min-height: ${({ width }) => width ? width : ''};
background:#FEFEFE99;
display:flex;
justify-content:center;
align-items:center;
border-radius:4px;
margin-right:24px;
flex-wrap:wrap;
.wrap-drodpwon{
display:flex;
width: 100%;
.text{
  font-family: Lato;
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  letter-spacing: 0%;
  color: #184A61;
  width:100%;
  display:flex;
  margin-bottom: 16px;
}
.menu{
  display:flex;
}
}
.incomplete{
    font-family: Lato;
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    letter-spacing: 0%;
    color: #A62F3D;
    width: 100%;
    margin-bottom: 8px;
}
`;

const ShowFlexBox = styled.div`
width: 100%;
display:flex;
`;

const CheckBoxWrap = styled.div`
display:flex;
gap: 16px;
width: ${({ width }) => width ? width : ''};
.text{
  font-family: Lato;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: 0%;
  color: ${({ disable }) => disable ? '#BDBDBD' : '#092F41'};
}
`;

const CheckBoxCardContainer = styled.div`
display:flex;
width:100%;
flex-wrap:wrap;
gap: 16px 0px;
`;

const HrisCardDisconnect = styled.div`
display:flex;
width:100%;
margin-right: ${({ margin }) => margin ? margin : '24px'};
padding: ${({ padding }) => padding ? padding : '16px'};
flex-wrap: wrap;
.wrap{
  display:flex;
  width:100%;
  .image{
    width:120px;
    height:120px;
    margin-right:8px;
    >img{
      width: 100%;
      height: 100%;
    }
  }
  .details{
    width: calc(100% - 128px);
    display:block;
    .menu{
      display:flex;
      width:100%;
      justify-content: flex-end;
    }
    .head{
      font-family: Lato;
      font-weight: 700;
      font-size: 18px;
      line-height: 24px;
      letter-spacing: 0%;
      color: #184A61;
      width: 100%;
      margin-bottom: 8px;
    }
    .status{
      font-family: Lato;
      font-weight: 400;
      font-size: 12px;
      line-height: 16px;
      letter-spacing: 0%;
      color: #A62F3D;
    }
    .name{
      font-family: Lato;
      font-weight: 700;
      font-size: 18px;
      line-height: 24px;
      letter-spacing: 0%;
      color: #184A61;
      width:100%;
      margin-bottom: 8px;
    }
    .incomplete{
      font-family: Lato;
      font-weight: 400;
      font-size: 12px;
      line-height: 16px;
      letter-spacing: 0%;
      color: #A62F3D;
      width:100%;
      margin-bottom: 8px;
    }
    .subText{
      font-family: Lato;
      font-weight: 400;
      font-size: 12px;
      line-height: 16px;
      letter-spacing: 0%;
      color: #BDBDBD;
      width:100%;
    }
    .nextcount{
      font-family: Lato;
      font-weight: 400;
      font-size: 16px;
      line-height: 20px;
      letter-spacing: 0%;
      color: #184A61;
      width:100%;
      margin-bottom: 8px;
    }
    .state-red{
      font-family: Lato;
      font-weight: 400;
      font-size: 12px;
      line-height: 16px;
      letter-spacing: 0%;
      color: #A62F3D;      
    }
    .state-green{
      font-family: Lato;
      font-weight: 400;
      font-size: 12px;
      line-height: 16px;
      letter-spacing: 0%;
      color: #418856; 
    }

  }
}
`;

const Title = styled.div`
  width:100%;
  display:flex;
  .small-text{
    font-family: Lato;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    color: #184A61;
  }
  .big-text{
    font-family: Lato;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    color: #184A61;
  }
  .icon{
    display:flex;
    margin: auto 0px auto auto;
    cursor:pointer;
  }
`;

const SubmitButton = styled.div`
  width: ${({width}) => width ? width : '165px'};
  display:flex;
  background: ${({background, disable}) => disable?"#EFEFEF": background ? background : '#F37A65'};
  border-radius:6px;
  cursor:pointer;
  cursor: ${({disable}) => disable ? "not-allowed" : 'pointer'};
  font-family: Lato;
  padding:${({padding}) => padding ? padding : '12px'};
  font-size: 16px;
  line-height: 20px;
  text-align: left;
  color: ${({color, disable}) => disable?"#989898": color ? color : 'white'};
  border: ${({border}) => border ? "1px solid #989898" : 'none'};
  justify-content: center;
  align-items: center;
  margin: ${({margin}) => margin ? margin : '0'};
`;

export { Layout, Header, BuddyTab, NoData, AddUserCard, HeaderTitle, ButtonHris, HrisCard, Time, TimeIcon, Wrapper, StyledModal, PopupLine, DownAngle, PopupHeading, FormField, ButtonWrapper, Heading, AddButton, BackgroundCard, ShowFlexBox, CheckBoxWrap, CheckBoxCardContainer, HrisCardDisconnect, Title, SubmitButton };